export default "__VITE_ASSET__55c19123__"